// store/modules/notifications.js

export default {
    namespaced: true,

    state: () => ({
        notifications: [],
        unreadCount: 0,
        connected: false,
        lastNotification: null,
        drawerOpen: false,
        hasNewNotification: false,
    }),

    getters: {

        notifications: state => state.notifications,

        unreadNotifications: state =>
            state.notifications.filter(n => n.status==='Unread'),

        unreadCount(state){
            return state.notifications.filter(n=>n.status==='Unread').length;
        },

        connected: state => state.connected,

        lastNotification: state => state.lastNotification,

        drawerOpen: state => state.drawerOpen,

        hasNewNotification: state => state.hasNewNotification,
    },

    mutations: {

        SET_STATE(state, payload){
            for (const key in payload) {
                if (payload.hasOwnProperty(key) && key in state) {
                    state[key] = payload[key];
                }
            }
        },

        SET_CONNECTED(state, value) {
            state.connected = value;
        },

        ADD_NOTIFICATION(state, notification) {
            state.notifications.unshift({
                ...notification,
                status: "Unread"
            });

            state.unreadCount++;

            state.lastNotification = notification;

            if(state.notifications.length>100){
                state.notifications.pop();
            }
        },

        TOGGLE_DRAWER(state) {
            state.drawerOpen = !state.drawerOpen;
        },

        OPEN_DRAWER(state) {
            state.drawerOpen = true;
        },

        CLOSE_DRAWER(state) {
            state.drawerOpen = false;
        },

        MARK_AS_READ(state, id) {

            const notification = state.notifications.find(
                n => n.id === id
            );

            if (notification && notification.status==='Unread') {
                notification.status = "Read";
                state.unreadCount--;
            }
            

        },

        MARK_ALL_AS_READ(state) {

            state.notifications.forEach(n => {
                n.status = "Read";
            });

            state.unreadCount = 0;

        },

        REMOVE_NOTIFICATION(state, id) {

            const index = state.notifications.findIndex(
                n => n.id === id
            );

            if (index > -1) {

                if (state.notifications[index].status==='Unread')
                    state.unreadCount--;

                state.notifications.splice(index, 1);

            }

        },

        CLEAR(state) {

            state.notifications = [];
            state.unreadCount = 0;
            state.lastNotification = null;
            state.drawerOpen = false;
            state.hasNewNotification = false;

        }

    },

    actions: {
        updateState({ commit }, newState) {
            commit('SET_STATE', newState);
        },
        addNotification({state, commit }, notification) {
            commit("ADD_NOTIFICATION", notification);
            state.hasNewNotification = true;
        },

        TOGGLE_DRAWER(state) {
            state.drawerOpen = !state.drawerOpen;
            state.hasNewNotification = false;
        },

        OPEN_DRAWER(state) {
            state.drawerOpen = true;
            state.hasNewNotification = false;
        },

        CLOSE_DRAWER(state) {
            state.drawerOpen = false;
        },

        markAsRead({ commit }, id) {
            commit("MARK_AS_READ", id);
        },

        markAllAsRead({ commit }) {
            commit("MARK_ALL_AS_READ");
        },

        removeNotification({ commit }, id) {
            commit("REMOVE_NOTIFICATION", id);
        },

        clear({ commit }) {
            commit("CLEAR");
        },

        setConnected({ commit }, value) {
            commit("SET_CONNECTED", value);
        }

    }

}